import styled from 'styled-components';

const StyledClientItem = styled.div`

img {
min-width: 100px;
min-height: 100px;
max-height: 180px;
max-width: 13vw;
margin: auto;

@media only screen and (max-width: 1230px) {
max-width: 20vw;
}

@media only screen and (max-width: 600px) {
max-width: 40vw;
}

}
`;

export default StyledClientItem;
